<template>
  <form>
    <div class="row">
      <div class="col-md-6">
        <label for="exampleInputEmail1" class="form-label">First Name</label>
        <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
      </div>
      <div class="col-md-6">
        <label for="exampleInputPassword1" class="form-label">Last Name</label>
        <input type="password" class="form-control" id="exampleInputPassword1" />
      </div>
      <div class="col-md-6">
        <label for="exampleInputEmail1" class="form-label">Username</label>
        <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
      </div>
      <div class="col-md-6">
        <label for="exampleInputPassword1" class="form-label">E-mail</label>
        <input type="password" class="form-control" id="exampleInputPassword1" />
      </div>
      <div class="col-md-6">
        <label for="exampleInputEmail1" class="form-label">DOB</label>
        <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
      </div>
      <div class="col-md-6">
        <label for="exampleInputPassword1" class="form-label">Gender</label>
        <input type="password" class="form-control" id="exampleInputPassword1" />
      </div>
      <div class="col-md-6">
        <label for="exampleInputEmail1" class="form-label">Services</label>
        <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
      </div>
      <div class="col-md-6">
        <label for="exampleInputPassword1" class="form-label">Branch</label>
        <input type="password" class="form-control" id="exampleInputPassword1" />
      </div>
    </div>
  </form>
</template>
